import { useState } from "react";

export const useRightPanel = () => {
  const [isRightPanelOpen, setIsRightPanelOpen] = useState(false);
  const [isPanelMinimized, setIsPanelMinimized] = useState(false);

  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isObjectOpen, setIsObjectOpen] = useState(false);

  const [currentObject, setCurrentObject] = useState({});
  const [mapClickResults, setMapClickResults] = useState(null);

  const closePanel = () => {
    setIsRightPanelOpen(false);
    setIsSearchOpen(false);
    setIsObjectOpen(false);
    setIsPanelMinimized(false);
    setMapClickResults(null);
  };

  return {
    isRightPanelOpen,
    setIsRightPanelOpen,

    isPanelMinimized,
    setIsPanelMinimized,

    isSearchOpen,
    setIsSearchOpen,

    isObjectOpen,
    setIsObjectOpen,

    currentObject,
    setCurrentObject,

    mapClickResults,
    setMapClickResults,

    closePanel,
  };
};